export function getLightToken(zoomUI) {
    const { semantic, shadow, typography, zIndex } = zoomUI;
    return {
        zIndex: zIndex.Tooltip,
        fontFamily: typography.fontFamily,
        fontSize: typography.fontSize.subtitle,
        fontWeight: typography.fontWeight.subtitle,
        lineHeight: typography.lineHeight.subtitle,
        borderColor: semantic.light.border.subtle.neutral,
        backgroundColor: semantic.light.fill.default,
        boxShadow: shadow.sm,
        textColor: semantic.light.text.stronger.neutral,
    };
}
